  !(function (e, o) {
    if ('function' == typeof define && define.amd) define(['exports'], o);
    else if ('undefined' != typeof exports) o(exports);
    else {
      var t = {};
      o(t), (e.bodyScrollLock = t);
    }
  })(this, function (exports) {
    'use strict';
    Object.defineProperty(exports, '__esModule', { value: !0 });
    var t = !1;
    if ('undefined' != typeof window) {
      var e = {
        get passive() {
          t = !0;
        },
      };
      window.addEventListener('testPassive', null, e), window.removeEventListener('testPassive', null, e);
    }
    function l(o) {
      return c.some(function (e) {
        return !(!e.options.allowTouchMove || !e.options.allowTouchMove(o));
      });
    }
    function d(e) {
      var o = e || window.event;
      return !!l(o.target) || 1 < o.touches.length || (o.preventDefault && o.preventDefault(), !1);
    }
    function n() {
      void 0 !== v && ((document.body.style.paddingRight = v), (v = void 0)),
        void 0 !== s && ((document.body.style.overflow = s), (s = void 0));
    }
    var i =
        'undefined' != typeof window &&
        window.navigator &&
        window.navigator.platform &&
        (/iP(ad|hone|od)/.test(window.navigator.platform) ||
          ('MacIntel' === window.navigator.platform && 1 < window.navigator.maxTouchPoints)),
      c = [],
      a = !1,
      u = -1,
      s = void 0,
      v = void 0;
    (exports.disableBodyScroll = function (r, e) {
      if (r) {
        if (
          !c.some(function (e) {
            return e.targetElement === r;
          })
        ) {
          var o = { targetElement: r, options: e || {} };
          (c = [].concat(
            (function (e) {
              if (Array.isArray(e)) {
                for (var o = 0, t = Array(e.length); o < e.length; o++) t[o] = e[o];
                return t;
              }
              return Array.from(e);
            })(c),
            [o]
          )),
            i
              ? ((r.ontouchstart = function (e) {
                  1 === e.targetTouches.length && (u = e.targetTouches[0].clientY);
                }),
                (r.ontouchmove = function (e) {
                  var o, t, n, i;
                  1 === e.targetTouches.length &&
                    ((t = r),
                    (i = (o = e).targetTouches[0].clientY - u),
                    l(o.target) ||
                      ((t && 0 === t.scrollTop && 0 < i) ||
                      ((n = t) && n.scrollHeight - n.scrollTop <= n.clientHeight && i < 0)
                        ? d(o)
                        : o.stopPropagation()));
                }),
                a || (document.addEventListener('touchmove', d, t ? { passive: !1 } : void 0), (a = !0)))
              : (function (e) {
                  if (void 0 === v) {
                    var o = !!e && !0 === e.reserveScrollBarGap,
                      t = window.innerWidth - document.documentElement.clientWidth;
                    o &&
                      0 < t &&
                      ((v = document.body.style.paddingRight), (document.body.style.paddingRight = t + 'px'));
                  }
                  void 0 === s && ((s = document.body.style.overflow), (document.body.style.overflow = 'hidden'));
                })(e);
        }
      } else
        console.error(
          'disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.'
        );
    }),
      (exports.clearAllBodyScrollLocks = function () {
        i
          ? (c.forEach(function (e) {
              (e.targetElement.ontouchstart = null), (e.targetElement.ontouchmove = null);
            }),
            a && (document.removeEventListener('touchmove', d, t ? { passive: !1 } : void 0), (a = !1)),
            (u = -1))
          : n(),
          (c = []);
      }),
      (exports.enableBodyScroll = function (o) {
        o
          ? ((c = c.filter(function (e) {
              return e.targetElement !== o;
            })),
            i
              ? ((o.ontouchstart = null),
                (o.ontouchmove = null),
                a &&
                  0 === c.length &&
                  (document.removeEventListener('touchmove', d, t ? { passive: !1 } : void 0), (a = !1)))
              : c.length || n())
          : console.error(
              'enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.'
            );
      });
  });

  class ModalBase extends HTMLElement {
    constructor() {
      super();

      this.trapFocusHandlers = {};
      this.isBusy = false;
    }

    get closeIcon() {
      return `
        <span class="button__flair"></span>

        <span class="button__inner">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 12.82 12.28">
            <path d="M12.82 12.16 8.34 7.91M0 0l4.56 4.32" stroke="currentColor" style="stroke-dashoffset: 0; stroke-dasharray: 6.2283px, 6.3283px;"></path>
            <path d="M.34 12.28 12.54.22" stroke="currentColor" style="stroke-dashoffset: 0; stroke-dasharray: none;"></path>
          </svg>
        </span>
      `;
    }

    get isOpen() {
      return this.modal?.classList.contains('modal--visible');
    }

    get hasOpenDrawerAfterModal() {
      let nextElement = this.modal.nextElementSibling;

      while (nextElement) {
        if (nextElement.querySelector('.drawer.open')) {
          return true;
        }

        nextElement = nextElement.nextElementSibling;
      }

      return false;
    }

    get hasOpenModalAfterThis() {
      const allModals = Array.from(document.querySelectorAll('.modal.modal--visible'));
      const modalsAfter = allModals.filter((modal) => {
        return this.modal !== modal && this.compareDocumentPosition(modal) & Node.DOCUMENT_POSITION_FOLLOWING;
      });

      return modalsAfter.length > 0;
    }

    get focusElement() {
      return this.modal.querySelector('button');
    }

    init(options) {
      if (this.modal) {
        return;
      }

      this.defaults = {
        id: '',
        customClass: '',
        headerTitle: '',
        content: '',
        closeLabel: 'Close',
        noClose: false,
        closeMethods: ['overlay', 'button', 'escape'],
        transitionDuration: 100,
      };

      this.opts = Object.assign({}, this.defaults, options);

      this.build();
      this.bindEvents();

      document.body.insertAdjacentElement('beforeend', this.modal);

      document.dispatchEvent(new CustomEvent('hover-button:apply'));
    }

    destroy() {
      if (this.modal === null) {
        return;
      }

      if (this.isOpen) {
        this.close();
      }

      this.unbindEvents();

      this.modal.remove();

      this.modal = null;
    }

    open(activeElement = null) {
      if (this.isBusy) {
        return;
      }

      this.isBusy = true;

      this.activeElement = activeElement;

      if (this.modal.style.removeProperty) {
        this.modal.style.removeProperty('display');
      } else {
        this.modal.style.removeAttribute('display');
      }

      document.getSelection().removeAllRanges();

      setTimeout(() => {
        this.modal.classList.add('modal--visible');
      }, 10);

      setTimeout(() => {
        this.trapFocus(this.modal, this.focusElement);
      }, this.opts.transitionDuration);

      window.bodyScrollLock.disableBodyScroll(this.modal.querySelector('.modal__content') || this.modal);

      document.documentElement.classList.add('page-no-scroll');

      const visibleDrawer = document.querySelector('.drawer.open');

      if (visibleDrawer) {
        this.modal.classList.add('modal--drawer-visible');
      }

      this.isBusy = false;
    }

    close() {
      if (this.isBusy || this.modal.hasAttribute('data-modal-no-close')) {
        return;
      }

      this.isBusy = true;

      this.modal.classList.add('modal--is-hiding');
      this.modal.classList.remove('modal--visible');

      const visibleModalsOrDrawers = document.querySelector('.modal.modal--visible, .drawer.open');

      if (!visibleModalsOrDrawers) {
        window.bodyScrollLock.clearAllBodyScrollLocks();

        document.documentElement.classList.remove('page-no-scroll');
      }

      if (this.isOpen) {
        this.close();
      }

      this.unbindEvents();

      setTimeout(() => {
        this.modal.classList.remove('modal--is-hiding');

        this.modal?.remove();
        this.modal = null;

        this.removeTrapFocus(this.activeElement);
      }, 600);

      setTimeout(() => {
        this.removeTrapFocus(this.activeElement);
      }, 50);

      this.isBusy = false;

      document.dispatchEvent(
        new CustomEvent('theme:modal:closed', {
          detail: {
            modalCustomClass: this.opts.customClass,
          },
        })
      );
    }

    getFocusableElements(container) {
      return Array.from(
        container.querySelectorAll(
          `summary, a[href], button:enabled, [tabindex]:not([tabindex^="-"]), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe`
        )
      );
    }

    trapFocus(container, elementToFocus = container) {
      const elements = this.getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      this.removeTrapFocus();

      this.trapFocusHandlers.focusin = (event) => {
        if (event.target === container || event.target === last || event.target === first) {
          document.addEventListener('keydown', this.trapFocusHandlers.keydown);
        }
      };

      this.trapFocusHandlers.focusout = () => {
        document.removeEventListener('keydown', this.trapFocusHandlers.keydown);
      };

      this.trapFocusHandlers.keydown = (event) => {
        if (event.code.toUpperCase() === 'TAB') {
          if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
          } else if ((event.target === container || event.target === first) && event.shiftKey) {
            event.preventDefault();
            last.focus();
          }
        }
      };

      document.addEventListener('focusout', this.trapFocusHandlers.focusout);
      document.addEventListener('focusin', this.trapFocusHandlers.focusin);

      elementToFocus.focus();

      if (elementToFocus.tagName === 'INPUT') {
        const selectableTypes = ['search', 'text', 'email', 'url'];

        if (selectableTypes.includes(elementToFocus.type) && elementToFocus.value) {
          elementToFocus.setSelectionRange(0, elementToFocus.value.length);
        }
      }
    }

    removeTrapFocus(elementToFocus = null) {
      document.removeEventListener('focusin', this.trapFocusHandlers.focusin);
      document.removeEventListener('focusout', this.trapFocusHandlers.focusout);
      document.removeEventListener('keydown', this.trapFocusHandlers.keydown);

      if (elementToFocus?.focus instanceof Function) {
        elementToFocus.focus();
      }
    }

    insertModalHeader() {
      return `
        ${
          this.opts.closeMethods.includes('button') &&
          !this.opts.headerTitle &&
          this.opts.closeButtonPosition !== 'content'
            ? `
          <button type="button" class="modal__close button button-reset hover:scale[1.15]">
            ${this.closeIcon}
            
            <span class="visually-hidden">${this.opts.closeLabel}</span>
          </button>
        `
            : ''
        }

        <div class="modal__header bg-gradient">
          ${
            this.opts.headerTitle
              ? `
            <h4 class="h5 m-0 flex-1 uppercase">${this.opts.headerTitle}</h4>
          `
              : ''
          }
          
          ${
            this.opts.closeMethods.includes('button') && this.opts.closeButtonPosition !== 'content'
              ? `
            <button type="button" class="modal__close button button-reset hover:scale[1.15]">
              ${this.closeIcon}
              
              <span class="visually-hidden">${this.opts.closeLabel}</span>
            </button>
          `
              : ''
          }
        </div>
      `;
    }

    insertModalContent() {
      const isDomContent = typeof this.opts.content !== 'string';
      const customClass = isDomContent ? this.opts.content.dataset.customClass : '';
      const contentElement = isDomContent ? this.opts.content.cloneNode(true) : null;

      if (this.opts.closeButtonPosition === 'content' && this.opts.closeButtonContainerSelector && contentElement) {
        const container = contentElement.content.querySelector(this.opts.closeButtonContainerSelector);

        if (container) {
          container.insertAdjacentHTML(
            'beforeend',
            `
            <button type="button" class="modal__close button button-reset hover:scale[1.15]">
              ${this.closeIcon}
              <span class="visually-hidden">${this.opts.closeLabel}</span>
            </button>
          `
          );
        }
      }

      return `
        <div class="modal__content ${customClass || ''}">
          ${
            this.opts.content
              ? typeof this.opts.content === 'string'
                ? this.opts.content
                : contentElement.innerHTML
              : ''
          }
        </div>
      `;
    }

    build() {
      this.modal = document.createElement('div');

      this.modal.classList.add('modal');
      this.modal.setAttribute('role', 'dialog');
      this.modal.setAttribute('aria-modal', 'true');

      if (this.opts.noClose) {
        this.modal.setAttribute('data-modal-no-close', 'true');
      }

      if (this.opts.headerTitle) {
        this.modal.setAttribute('aria-label', this.opts.headerTitle);
      }

      if (this.opts.id) {
        this.modal.id = this.opts.id;
      }

      if (this.opts.customClass) {
        this.modal.className += ` ${this.opts.customClass}`;
      }

      this.modal.style.display = 'none';

      const markup = `
        <div class="modal__box">
          ${this.insertModalHeader()}
          ${this.insertModalContent()}
        </div>
        
        <overlay-component class="overlay overlay--modal"></overlay-component>
      `;

      const fragment = this.createFragmentFromMarkup(markup);

      this.modal.appendChild(fragment);

      this.modalCloseBtn = this.modal.querySelector('.modal__close');
      this.overlay = this.modal.querySelector('overlay-component');

      const modalImages = this.modal.querySelectorAll('.fade-in-image');

      modalImages.forEach((image) => {
        image.classList.remove('fade-in-image');
      });
    }

    createFragmentFromMarkup(markup) {
      const fragment = document.createDocumentFragment();
      const tempContainer = document.createElement('div');

      tempContainer.innerHTML = markup;

      while (tempContainer.firstChild) {
        fragment.appendChild(tempContainer.firstChild);
      }

      return fragment;
    }

    bindEvents() {
      this.events = {
        clickCloseBtn: this.close.bind(this),
        clickOverlay: this.handleClickOutside.bind(this),
        escClick: this.handleEscClick.bind(this),
      };

      if (this.opts.closeMethods.includes('button')) {
        this.modalCloseBtn?.addEventListener('click', this.events.clickCloseBtn);
        this.overlay.addEventListener('click', this.events.clickCloseBtn);
      }

      this.modal.addEventListener('mousedown', this.events.clickOverlay);
      document.addEventListener('keydown', this.events.escClick);
    }

    handleEscClick(evt) {
      if (
        this.opts.closeMethods.includes('escape') &&
        (evt.key === 'Escape' || evt.key === 'Esc') &&
        this.isOpen &&
        !this.hasOpenDrawerAfterModal &&
        !this.hasOpenModalAfterThis
      ) {
        this.close();
      }
    }

    handleClickOutside(event) {
      const scrollbarWidth = this.modal.offsetWidth - this.modal.clientWidth;
      const clickedOnScrollbar = event.clientX >= this.modal.offsetWidth - 15;
      const isScrollable = this.modal.scrollHeight !== this.modal.offsetHeight;

      if (navigator.platform === 'MacIntel' && scrollbarWidth === 0 && clickedOnScrollbar && isScrollable) {
        return;
      }

      if (
        this.opts.closeMethods.includes('overlay') &&
        !this.findAncestor(event.target, 'modal') &&
        event.clientX < this.modal.clientWidth
      ) {
        this.close();
      }
    }

    findAncestor(el, cls) {
      while (el && (el = el.parentElement)) {
        if (el.classList.contains(cls)) {
          return el;
        }
      }

      return null;
    }

    unbindEvents() {
      if (this.opts.closeMethods.includes('button')) {
        this.modalCloseBtn?.removeEventListener('click', this.events.clickCloseBtn);
        this.overlay.removeEventListener('click', this.events.clickCloseBtn);
      }

      this.modal.removeEventListener('mousedown', this.events.clickOverlay);
    }
  }

  class StoreLocatorPopup extends ModalBase {
    constructor() {
      super();

      this.storageKey = 'rustic_locator_confirmed';
      this.content = this.querySelector('.modal-content-markup');
      this.isEditor = window.Shopify && window.Shopify.designMode;
      this.sectionId = this.closest('.shopify-section').id.replace('shopify-section-', '');

      if (!this.content) {
        return;
      }

      if (!this.isEditor && sessionStorage.getItem(this.storageKey)) {
        return;
      }

      this.cleanupExistingModals();

      const customClass =
        this.dataset.customClass?.trim() ||
        `store-locator-popup ${this.dataset.colorScheme || ''}${this.dataset.hasOverlay === 'true' ? ' store-locator-popup--overlay' : ''}`.trim() ||
        'store-locator-popup';

      this.init({
        content: this.content,
        id: 'StoreLocatorPopup',
        customClass: customClass,
        transitionDuration: 0,
        noClose: true,
      });

      if (this.isEditor) {
        this.initEditorListeners();
      } else {
        this.open();
      }
    }

    cleanupExistingModals() {
      const orphans = document.querySelectorAll('.modal.store-locator-popup, #StoreLocatorPopup');

      orphans.forEach((modal) => modal.remove());

      window.bodyScrollLock?.clearAllBodyScrollLocks();
      document.documentElement.classList.remove('page-no-scroll');
    }

    initEditorListeners() {
      document.addEventListener('shopify:section:select', (event) => {
        if (event.detail.sectionId === this.sectionId) {
          this.open();
        }
      });

      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.detail.sectionId === this.sectionId) {
          this.close();
        }
      });
    }

    open(isSubmitted, activeElement = null) {
      this.activeElement = activeElement;

      super.open(activeElement);
      this.bindButtonEvents();
    }

    bindButtonEvents() {
      if (!this.modal) {
        return;
      }

      const confirmBtn = this.modal.querySelector('.button-primary');
      if (confirmBtn) {
        confirmBtn.addEventListener('click', (e) => {
          e.preventDefault();

          if (!this.isEditor) {
            sessionStorage.setItem(this.storageKey, 'true');
          }

          this.close();

          setTimeout(() => this.modal?.remove(), 600);
        });
      }

      const backBtn = this.modal.querySelector('.button-outline');

      if (backBtn) {
        backBtn.addEventListener('click', (e) => {
          e.preventDefault();

          if (this.isEditor) {
            alert('Back button clicked (Disabled in Editor)');
            return;
          }

          if (document.referrer && document.referrer.indexOf(window.location.host) !== -1) {
            window.history.back();
          } else {
            window.location.href = '/';
          }
        });
      }
    }

    close() {
      if (this.isBusy || !this.modal) {
        return;
      }

      this.isBusy = true;
      this.modal.classList.add('modal--is-hiding');
      this.modal.classList.remove('modal--visible');

      const visibleModalsOrDrawers = document.querySelector('.modal.modal--visible, .drawer.open');

      if (!visibleModalsOrDrawers) {
        window.bodyScrollLock.clearAllBodyScrollLocks();
        document.documentElement.classList.remove('page-no-scroll');
      }

      setTimeout(() => {
        this.modal?.classList.remove('modal--is-hiding');
        if (this.isEditor) {
          if (this.modal) {
            this.modal.style.display = 'none';
          }
        } else {
          this.modal?.remove();
        }
        this.activeElement?.focus();
      }, 600);

      this.isBusy = false;
    }
  }

  if (!window.customElements.get('store-locator-popup')) {
    customElements.define('store-locator-popup', StoreLocatorPopup);
  }
